import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: {
    account: "string";
    departmentName: "string";
    employeeCode: "string";
    name: "string";
    positionName: "string";
  }[];
  formReq: any[];
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  formReq: [],
  data: [],
};

const getLeaveManagerReqSlice = createSlice({
  name: "getLeaveManagerReq",
  initialState,
  reducers: {
    updateFormReqLeaveManager: (state, action) => {
      state.formReq = action.payload;
    },
    getLeaveManagerReqStart: (state) => {
      state.status = ReduxStateType.LOADING;
    },
    getLeaveManagerReqSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getLeaveManagerReqFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetLeaveManagerReq: () => {
      return { ...initialState };
    },
  },
});

export const {
  getLeaveManagerReqStart,
  getLeaveManagerReqSuccess,
  getLeaveManagerReqFailed,
  resetLeaveManagerReq,
  updateFormReqLeaveManager,
} = getLeaveManagerReqSlice.actions;

export default getLeaveManagerReqSlice.reducer;
